const inrFmt = new Intl.NumberFormat("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export const inr = (v) => `₹${inrFmt.format(Number(v) || 0)}`;
export const num = (v) => inrFmt.format(Number(v) || 0);

export function ddmmyyyy(iso) {
  if (!iso) return "";
  const [y, m, d] = iso.slice(0, 10).split("-");
  return `${d}/${m}/${y}`;
}

export function todayIST() {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Kolkata" }).format(new Date());
}

const r2 = (v) => Math.round((v + Number.EPSILON) * 100) / 100;

export function calcItem(it) {
  const taxable = r2((Number(it.qty) || 0) * (Number(it.rate) || 0));
  const tax = r2((taxable * (Number(it.gst) || 0)) / 100);
  return { taxable, tax, total: r2(taxable + tax) };
}

export function calcTotals(items) {
  return items.reduce(
    (acc, it) => {
      const c = calcItem(it);
      return { taxable: r2(acc.taxable + c.taxable), tax: r2(acc.tax + c.tax), total: r2(acc.total + c.total) };
    },
    { taxable: 0, tax: 0, total: 0 }
  );
}

export const STATUSES = ["Draft", "Accepted", "Cancelled"];
export const UOMS = ["Mtr", "Pcs", "Kg"];
export const GSTS = [0, 5, 12, 18];
export const PRODUCT_LINES = ["Shirts", "Pants (white label)"];
export const LR_STATUSES = ["Booked", "In Transit", "At Transporter Location", "Out for Delivery", "Delivered", "GRN Done"];
export const lrSlug = (s) => s.toLowerCase().replace(/\s+/g, "-");
